/* Verolae · Reviews Carousel — vanilla track carousel.
   Port of the source section's inline script (reviews_carousel_hfT3Qd): translateX track,
   N cards per page on desktop / 1 below 768px, dots built at runtime, disabled-state arrows, swipe
   (50px threshold), rebuild + reset on resize (200ms debounce). No dependencies (the source does not
   use Swiper). Scoped per instance via data-section-id so several sections can share a page; theme-editor
   aware (section load/unload, block select jumps to the page holding that review). */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.verolae-reviews-carousel[data-section-id]';
  var instances = {};

  function create(root) {
    var id = root.getAttribute('data-section-id');
    if (!id || instances[id]) return;

    var viewport = root.querySelector('.rc__viewport');
    var track    = root.querySelector('.rc__track');
    var dotsWrap = root.querySelector('.rc__dots');
    var prevBtn  = root.querySelector('.rc__arrow--prev');
    var nextBtn  = root.querySelector('.rc__arrow--next');

    if (!viewport || !track) return;

    var CARDS_DESKTOP = parseInt(root.getAttribute('data-cards-desktop'), 10) || 3;
    var current = 0;

    function total() {
      return track.querySelectorAll('.rc__slide').length;
    }

    function onMobile() {
      return window.innerWidth < 768;
    }

    function cpv() {
      return onMobile() ? 1 : CARDS_DESKTOP;
    }

    function totalPages() {
      return Math.max(1, Math.ceil(total() / cpv()));
    }

    function updateButtons() {
      var pages = totalPages();
      if (prevBtn) {
        if (current === 0) {
          prevBtn.disabled = true;
          prevBtn.classList.add('is-disabled');
        } else {
          prevBtn.disabled = false;
          prevBtn.classList.remove('is-disabled');
        }
      }
      if (nextBtn) {
        if (current === pages - 1) {
          nextBtn.disabled = true;
          nextBtn.classList.add('is-disabled');
        } else {
          nextBtn.disabled = false;
          nextBtn.classList.remove('is-disabled');
        }
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var n = totalPages();
      if (n <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      } else {
        if (prevBtn) prevBtn.style.display = 'flex';
        if (nextBtn) nextBtn.style.display = 'flex';
      }
      for (var i = 0; i < n; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rc__dot' + (i === current ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.setAttribute('aria-selected', i === current ? 'true' : 'false');
        btn.dataset.idx = i;
        btn.addEventListener('click', function () {
          goTo(parseInt(this.dataset.idx, 10));
        });
        dotsWrap.appendChild(btn);
      }
    }

    function syncDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.rc__dot');
      dots.forEach(function (d, i) {
        var active = i === current;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(idx) {
      var pages = totalPages();
      if (pages <= 1) {
        track.style.transform = 'translateX(0px)';
        return;
      }
      current = Math.max(0, Math.min(idx, pages - 1));

      var offset = current * viewport.offsetWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';
      syncDots();
      updateButtons();
    }

    function onPrev() { goTo(current - 1); }
    function onNext() { goTo(current + 1); }
    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    var touchStartX = 0;
    function onTouchStart(e) {
      touchStartX = e.touches[0].clientX;
    }
    function onTouchEnd(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(current + (diff > 0 ? 1 : -1));
      }
    }
    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: true });

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        current = 0;
        buildDots();
        goTo(0);
      }, 200);
    }
    window.addEventListener('resize', onResize);

    instances[id] = {
      refresh: function () {
        buildDots();
        goTo(0);
      },
      goToSlide: function (slideIndex) {
        goTo(Math.floor(slideIndex / cpv()));
      },
      destroy: function () {
        window.removeEventListener('resize', onResize);
        clearTimeout(resizeTimer);
        delete instances[id];
      }
    };

    buildDots();
    goTo(0);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(create);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(ROOT_SELECTOR);
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      if (instances[id]) instances[id].destroy();
      create(root);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (id && instances[id]) instances[id].destroy();
    });
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('.rc__slide');
      var root = event.target.closest(ROOT_SELECTOR);
      if (!slide || !root) return;
      var inst = instances[root.getAttribute('data-section-id')];
      var index = parseInt(slide.getAttribute('data-slide-index'), 10);
      if (!inst || isNaN(index)) return;
      inst.goToSlide(index);
    });
  }
})();
